export const colors = {
  cost: {
    1: 'LightGrey',
    2: 'MediumPurple',
    3: 'MediumBlue',
    4: 'Magenta',
    5: 'DarkOrange',
  },
  features: {
    Dragon: 'Maroon',
    Dwarf: 'Chocolate',
    Demon: 'BlueViolet',
    Ogre: 'DeepSkyBlue',
    Elf: 'DodgerBlue',
    Undead: 'Grey',
    Orc: 'Red',
    Goblin: 'FireBrick',
    Element: 'Yellow',
    Human: 'White',
    Naga: 'MediumBlue',
    Troll: 'Silver',
    Beast: 'Green',
    Assassin: 'Khaki',
    'Demon Hunter': 'Indigo',
    Druid: 'DarkOrange',
    Hunter: 'SpringGreen',
    Knight: 'Pink',
    Mage: 'Turquoise',
    Mech: 'Sienna',
    Shaman: 'Blue',
    Warlock: 'MediumPurple',
    Warrior: 'PeachPuff',
  },
};



// WEBPACK FOOTER //
// ./src/colors.tsx